import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SidebarComponent } from './sidebar.component';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';


@NgModule({
    imports: [RouterModule, CommonModule, TranslateModule ],
    declarations: [ SidebarComponent ],
    exports: [SidebarComponent, TranslateModule ]
})

export class SidebarModule {}
